var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: "#Content", offset: 0}),expression:"{el: \"#Content\", offset: 0}"}],staticClass:"gray"},[_vm._v(" Back to top ")])}
var staticRenderFns = []

export { render, staticRenderFns }